import { OrderFrame } from '@ca/common'
import { useConfigConditionFrameCheck } from 'features/config/useConfigCondition'
import { useCallback } from 'react'
import useOrderValues from './values/useOrderValues'

const useIsTempleRequired = () => {
  const values = useOrderValues({})
  const check = useConfigConditionFrameCheck({
    values,
  })

  const checkIsTempleRequired = useCallback(
    (frame: OrderFrame) => {
      return check('frames:isTempleRequired', frame)
    },
    [check]
  )

  return checkIsTempleRequired
}

export default useIsTempleRequired
